import { useEffect, useState } from 'react'

// False for the first painted frame so charts render at zero and their CSS transitions
// carry them up to the real values; later data changes reuse the same transitions.
export function useGrowIn() {
  const [shown, setShown] = useState(false)
  useEffect(() => {
    let id = requestAnimationFrame(() => {
      id = requestAnimationFrame(() => setShown(true))
    })
    return () => cancelAnimationFrame(id)
  }, [])
  return shown
}
